"use strict";

function _typeof(e) {
    return (_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
        return typeof e
    } : function(e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
    })(e)
}

function _classCallCheck(e, t) {
    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
}

function _defineProperties(e, t) {
    for (var r = 0; r < t.length; r++) {
        var n = t[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, _toPropertyKey(n.key), n)
    }
}

function _createClass(e, t, r) {
    return t && _defineProperties(e.prototype, t), r && _defineProperties(e, r), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e
}

function _inherits(e, t) {
    if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
    e.prototype = Object.create(t && t.prototype, {
        constructor: {
            value: e,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(e, "prototype", {
        writable: !1
    }), t && _setPrototypeOf(e, t)
}

function _createSuper(e) {
    var t = _isNativeReflectConstruct();
    return function() {
        var r, n = _getPrototypeOf(e);
        return _possibleConstructorReturn(this, t ? (r = _getPrototypeOf(this).constructor, Reflect.construct(n, arguments, r)) : n.apply(this, arguments))
    }
}

function _possibleConstructorReturn(e, t) {
    if (t && ("object" === _typeof(t) || "function" == typeof t)) return t;
    if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(e)
}

function _assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e
}

function _wrapNativeSuper(e) {
    var t = "function" == typeof Map ? new Map : void 0;
    return (_wrapNativeSuper = function(e) {
        if (null === e || !_isNativeFunction(e)) return e;
        if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== t) {
            if (t.has(e)) return t.get(e);
            t.set(e, r)
        }

        function r() {
            return _construct(e, arguments, _getPrototypeOf(this).constructor)
        }
        return r.prototype = Object.create(e.prototype, {
            constructor: {
                value: r,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), _setPrototypeOf(r, e)
    })(e)
}

function _construct(e, t, r) {
    return (_construct = _isNativeReflectConstruct() ? Reflect.construct.bind() : function(e, t, r) {
        var n = [null];
        return n.push.apply(n, t), t = new(Function.bind.apply(e, n)), r && _setPrototypeOf(t, r.prototype), t
    }).apply(null, arguments)
}

function _isNativeReflectConstruct() {
    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
    if (Reflect.construct.sham) return !1;
    if ("function" == typeof Proxy) return !0;
    try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function() {}))), !0
    } catch (e) {
        return !1
    }
}

function _isNativeFunction(e) {
    try {
        return -1 !== Function.toString.call(e).indexOf("[native code]")
    } catch (t) {
        return "function" == typeof e
    }
}

function _setPrototypeOf(e, t) {
    return (_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
        return e.__proto__ = t, e
    })(e, t)
}

function _getPrototypeOf(e) {
    return (_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
        return e.__proto__ || Object.getPrototypeOf(e)
    })(e)
}

function _defineProperty(e, t, r) {
    return (t = _toPropertyKey(t)) in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[t] = r, e
}

function _toPropertyKey(e) {
    return "symbol" === _typeof(e = _toPrimitive(e, "string")) ? e : String(e)
}

function _toPrimitive(e, t) {
    if ("object" !== _typeof(e) || null === e) return e;
    var r = e[Symbol.toPrimitive];
    if (void 0 === r) return ("string" === t ? String : Number)(e);
    if ("object" !== _typeof(r = r.call(e, t || "default"))) return r;
    throw new TypeError("@@toPrimitive must return a primitive value.")
}! function e(t, r, n) {
    function o(u, c) {
        if (!r[u]) {
            if (!t[u]) {
                var s = "function" == typeof require && require;
                if (!c && s) return s(u, !0);
                if (i) return i(u, !0);
                throw (c = new Error("Cannot find module '" + u + "'")).code = "MODULE_NOT_FOUND", c
            }
            s = r[u] = {
                exports: {}
            }, t[u][0].call(s.exports, (function(e) {
                return o(t[u][1][e] || e)
            }), s, s.exports, e, t, r, n)
        }
        return r[u].exports
    }
    for (var i = "function" == typeof require && require, u = 0; u < n.length; u++) o(n[u]);
    return o
}({
    1: [function(e, t, r) {
        customElements.get("s-drawer-size-guide") || customElements.define("s-drawer-size-guide", function() {
            _inherits(t, _wrapNativeSuper(HTMLElement));
            var e = _createSuper(t);

            function t() {
                var r;
                return _classCallCheck(this, t), _defineProperty(_assertThisInitialized(r = e.call(this)), "openSizeGuideDrawer", (function() {
                    r.classList.add("is-active")
                })), _defineProperty(_assertThisInitialized(r), "closeSizeGuideDrawer", (function() {
                    r.classList.remove("is-active")
                })), _defineProperty(_assertThisInitialized(r), "closeAllModalsDrawer", (function() {
                    window.PubSub.publish("product-drawer-close", r.openSizeGuideDrawer)
                })), r
            }
            return _createClass(t, [{
                key: "connectedCallback",
                value: function() {
                    this.backBtn = this.querySelector(".js-modal-size-guide__btn-back"), this.closeBtn = this.querySelector(".js-modal-size-guide__btn-close"), this.closeSizeGuideUnsubscriber = window.PubSub.subscribe("close-size-guide-drawer", this.closeSizeGuideDrawer), this.openSizeGuideUnsubscriber = window.PubSub.subscribe("open-size-guide-drawer", this.openSizeGuideDrawer), this.closeAllDrawersUnsubscriber = window.PubSub.subscribe("product-drawer-close", this.closeSizeGuideDrawer), this.backBtn.addEventListener("click", this.closeSizeGuideDrawer), this.closeBtn.addEventListener("click", this.closeSizeGuideDrawer)
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                    this.backBtn.removeEventListener("click", this.closeSizeGuideDrawer), this.closeBtn.removeEventListener("click", this.closeAllModals), this.closeSizeGuideUnsubscriber(), this.openSizeGuideUnsubscriber(), this.closeAllDrawersUnsubscriber()
                }
            }]), t
        }())
    }, {}]
}, {}, [1]);